import styled from "styled-components";

/**
 * §7: "The divider spans the content width — it is inset by the panel padding,
 * never full-bleed." Inside a Panel that is automatic, because the Panel's own
 * 20px padding already insets it. Do not add negative margins to bleed it out.
 *
 * 24px above and below (§3).
 */
const Divider = styled.hr`
	width: 100%;
	height: 0;
	margin: var(--space-6) 0;
	border: none;
	border-top: var(--border-strong);
`;

export default Divider;
